import Vue from "vue";
import api from "../../plugins/api";

export default {
    namespaced: true,
    state: {
        confidentiality: {},
        confidentialityType: {}
    },
    actions: {
        getLastConfidentiality: ({ commit }) => {
            return Vue.http.get('confidentiality/last', { emulateJSON: true })
                .then(response => commit("SET_CONFIDENTIALITY", response.body))
                .catch(error => { api.error(commit, error) })
        },
        setConfidentiality: ({ commit }, data) => {
            return Vue.http.put('confidentiality', { type_id: data.type_id, text: data.text }, { emulateJSON: true }).catch(error => { api.error(commit, error) })
        },
        updateConfidentiality: ({ commit }, data) => {
            return Vue.http.put('confidentiality/' + data.confidentiality_id, { text: data.text }, { emulateJSON: true }).catch(error => { api.error(commit, error) })
        },
        getConfidentialityType: ({ commit }) => {
            return Vue.http.get('confidentiality/type', { emulateJSON: true })
                .then(response => commit("SET_CONFIDENTIALITY_TYPE", response.body))
                .catch(error => { api.error(commit, error) })
        },
    },
    mutations:{
        SET_CONFIDENTIALITY: (state, data) => {
            return state.confidentiality = data
        },
        SET_CONFIDENTIALITY_TYPE: (state, data) => {
            return state.confidentialityType = data
        }
    },
    getters: {
        confidentiality: (state) => state.confidentiality,
        confidentialityType: (state) => state.confidentialityType
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/confidentiality.js